import { render, staticRenderFns } from "./AptReminder.vue?vue&type=template&id=f64a8db2&scoped=true"
import script from "./AptReminder.vue?vue&type=script&lang=js"
export * from "./AptReminder.vue?vue&type=script&lang=js"
import style0 from "./AptReminder.vue?vue&type=style&index=0&id=f64a8db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64a8db2",
  null
  
)

export default component.exports